import { useEffect, useState } from "react"
import { deleteDistrict, getDistricts } from "../../../fetch/districts"
import { District, UserRole } from "../../../../types"
import "./adminDistricts.css"
import {
  DeleteIcon,
  EditIcon,
  IconButton,
} from "../../../components/button/IconButton"
import { EditDistrict } from "./EditDistrict"
import { Button } from "../../../components/button/Button"
import { useWatcher } from "@/lib/state/useWatcher"
import { userState } from "@/store/user"
import { hasUserAccess } from "@/utils/user"
import { DataTable } from "@/components/dataTable/DataTable"

export const AdminDistricts = () => {
  const [districts, setDistricts] = useState<District[]>([])
  const [editRow, setEdit] = useState<undefined | Partial<District>>()
  const user = useWatcher(userState)
  const [expanded, setExpanded] = useState<Set<number>>(new Set())

  const init = () => {
    getDistricts().then(async (res) => {
      const json = await res.json()
      if (json) {
        setDistricts(json)
      }
    })
  }
  useEffect(() => {
    init()
  }, [])

  const onDelete = (id: number) => {
    deleteDistrict(id).then(init)
  }

  const onEdit = (district: Partial<District>) => {
    setEdit({ ...district })
  }

  const onClose = (updated?: boolean) => {
    setEdit(undefined)
    updated && init()
  }

  function setEditValue<k extends keyof District>(
    field: k,
    value: District[k]
  ) {
    if (editRow != null) {
      setEdit({ ...editRow, [field]: value })
    }
  }

  const hasEditAccess = hasUserAccess({
    neededRole: UserRole.Admin,
    userRole: user.role,
  })

  return (
    <>
      {hasEditAccess ? (
        <>
          <div className="districts-add">
            <Button
              onClick={() =>
                setEdit({
                  name: "",
                  shift: 8,
                  workers: 1,
                  concurrentShifts: 1,
                })
              }
            >
              Pievienot iecirkni
            </Button>
          </div>
          <EditDistrict
            district={editRow}
            onClose={onClose}
            setEditValue={setEditValue}
          />
        </>
      ) : null}
      {districts.map((district, i) => (
        <div
          className={`group-districts ${expanded.has(i) ? "expanded" : ""}`}
          key={`district-${district.id}-${i}`}
        >
          <div
            className="row-district"
            onClick={() =>
              setExpanded((s) => {
                const updated = new Set(s)
                updated.has(i) ? updated.delete(i) : updated.add(i)
                return updated
              })
            }
          >
            <span className="row-district-title">{district.name}</span>
            <span className="row-district-info">
              {district.workers} Darbiniek
              {district.workers % 10 === 1 ? "s" : "i"}
            </span>
            {hasEditAccess ? (
              <div className="row-district-edit">
                <IconButton
                  onClick={(ev) => {
                    ev.stopPropagation()
                    onEdit(district)
                  }}
                >
                  {EditIcon}
                </IconButton>
                <IconButton
                  onClick={(ev) => {
                    ev.stopPropagation()
                    onDelete(district.id)
                  }}
                >
                  {DeleteIcon}
                </IconButton>
              </div>
            ) : null}
          </div>
          <div className="group-districts-items">
            <DataTable
              columns={[
                {
                  accessorKey: "id",
                  header: "#",
                  cell: ({ row }) => {
                    return <div>{row.index + 1}.</div>
                  },
                },
                {
                  accessorKey: "name",
                  header: "Darbinieks",
                  cell: ({ row }) => {
                    const og = row.original
                    return <div>{og.name}</div>
                  },
                },
              ]}
              data={district.users ?? []}
            />
            {/* {district.users?.map((user) => (
              <div key={user.id}>{user.name}</div>
            ))} */}
          </div>
        </div>
      ))}
    </>
  )
}
